import { combineReducers } from 'redux';

import { ConnectedActionHandlerMap as detailsReducer, namespace as detailsNamespace } from './details/returns.details.reducer';
import { ConnectedActionHandlerMap as filteringReducer, namespace as filteringNamespace } from './filtering/returns.filtering.reducer';
import { ConnectedActionHandlerMap as gridReducer, namespace as gridNamespace } from './grid/returns.grid.reducer';
import { ConnectedActionHandlerMap as navReducer, namespace as navNamespace } from './nav/returns.nav.reducer';
import {
  ConnectedActionHandlerMap as selectedReturnsReducer,
  namespace as selectedReturnsNamespace,
} from './selected-returns/returns.selected-returns.reducer';

export const combinedReducer = combineReducers({
  [detailsNamespace]: detailsReducer,
  [filteringNamespace]: filteringReducer,
  [gridNamespace]: gridReducer,
  [navNamespace]: navReducer,
  [selectedReturnsNamespace]: selectedReturnsReducer,
});

export { namespace } from './returns.reducer.metadata';
